module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiA2NGMyNDcuNCAwIDQ0OCAyMDAuNiA0NDggNDQ4cy0yMDAuNiA0NDgtNDQ4IDQ0OFM2NCA3NTkuNCA2NCA1MTIgMjY0LjYgNjQgNTEyIDY0eiBtMjYxLjcgMjY1LjRhMzIgMzIgMCAwIDAtNDIuMi0yLjdsLTMgMi43LTI5Ni45IDI5Ni45LTEyMC45LTEyMC45YTMyIDMyIDAgMCAwLTQ3LjkgNDIuMmwyLjcgMyAxMzUuOCAxMzUuOGEzMS45IDMxLjkgMCAwIDAgMTQuMyA4LjMgMzIgMzIgMCAwIDAgMzguNS0wLjZsMi45LTIuNiAzMTYuOC0zMTYuOGEzMiAzMiAwIDAgMCAwLTQ1LjJ6IiBmaWxsPSIjMCIgcC1pZD0iNDE4NCI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Checkmark-filled.svg
// module id = 2SsO
// module chunks = 75